import React, { Component } from "react";
import ReeValidate from 'ree-validate'
import { connect } from "react-redux";
import { sendBrandRequest } from "../store/actions/auth";
import {convertReadbleFormat} from './../helpers';

const $ = window.$;

class RequestBrand extends Component {

  constructor(props) {
    super(props);
    this.validator = new ReeValidate({
      email: 'required|email',
      lastName: 'required',
      firstName: 'required',
      phoneNumber: 'required',
      companyName: 'required',
      website: ''
    });
    this.state = {
      formData: {
        email: '',
        phoneNumber: '',
        companyName: '',
        lastName: '',
        firstName: '',
        website: ''
      },
      formErrors: this.validator.errors
    };
  }

  componentDidMount() {
    $('#myModal2').on('hidden.bs.modal', () => {
      this.closeModal();
    });
  }

  handleSubmit = e => {
    e.preventDefault();
    const { removeError } = this.props;
    removeError();
    const { formData } = this.state;
    const { errors } = this.validator;
    this.validator.validateAll(formData).then(success => {
      if (success) {
        this.props.sendBrandRequest({
            ...formData
        }).then(() => {
            $('#myModal2').modal('hide');
        })
      } else {
        this.setState({ formErrors: errors });
      }
    });
  };

  handleChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    const { errors } = this.validator;
    errors.remove(name);
    this.setState({ formData: { ...this.state.formData, [name]: value } });
    this.validator.validate(name, value).then(() => {
      this.setState({ formErrors: errors });
    });
  };

  closeModal = () => {
    this.validator.errors.clear();
    this.props.removeError();
    this.setState(
      {
        formData: {
            email: '',
            phoneNumber: '',
            companyName: '',
            lastName: '',
            firstName: '',
            website: ''
        },
        formErrors: this.validator.errors
      },
      () => $('#myModal2').modal('hide')
    );
  };

  render() {
    const { formData, formErrors } = this.state;

    return (
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" onClick={this.closeModal}>
              &times;
            </button>
            <h3>&nbsp;</h3>
          </div>
          <div className="modal-body">
            <div className="row">
                <div className="col-md-6">
                    <h1>Talk to a featured brand specialist to learn more about how to get your brand featured.</h1>
                    <ul>
                        <li>Get your questions answered on the spot</li>
                        <li>See Fitbanx in action via live screensharing</li>
                        <li>Find out if Fitbanx is a good fit for your needs</li>
                    </ul>
                </div>
                <div className="col-md-6">
                    <form onSubmit={this.handleSubmit} noValidate>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="fname">First Name:</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="firstName"
                                        placeholder="First name"
                                        name="firstName"
                                        onChange={this.handleChange}
                                        required
                                        value={formData.firstName}
                                    />
                                    {formErrors.has('firstName') && (
                                    <span className="error text-danger">
                                        {convertReadbleFormat(formErrors.first('firstName'))}
                                    </span>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="lname">Last Name:</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="lastName"
                                        placeholder="Last name"
                                        name="lastName"
                                        onChange={this.handleChange}
                                        required
                                        value={formData.lastName}
                                    />
                                    { formErrors.has('lastName') && (
                                        <span className="error text-danger">
                                            {convertReadbleFormat(formErrors.first('lastName'))}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="email">Email:</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="email"
                                        placeholder="Enter email"
                                        name="email"
                                        onChange={this.handleChange}
                                        required
                                        value={formData.email}
                                    />
                                    {formErrors.has('email') && (
                                        <span className="error text-danger">
                                            {convertReadbleFormat(formErrors.first('email'))}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="phn">Phone number:</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="phoneNumber"
                                        placeholder="Phone Number"
                                        name="phoneNumber"
                                        onChange={this.handleChange}
                                        required
                                        value={formData.phoneNumber}
                                    />
                                    { formErrors.has('phoneNumber') && (
                                        <span className="error text-danger">
                                            {convertReadbleFormat(formErrors.first('phoneNumber'))}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="cname">Company name:</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="companyName"
                                        placeholder="Company Name"
                                        name="companyName"
                                        onChange={this.handleChange}
                                        required
                                        value={formData.companyName}
                                    />
                                    { formErrors.has('companyName') && (
                                        <span className="error text-danger">
                                            {convertReadbleFormat(formErrors.first('companyName'))}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="company website">Company website:</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="cname"
                                        placeholder="Company Website"
                                        name="website"
                                        onChange={this.handleChange}
                                        required
                                        value={formData.website}
                                    />
                                    { formErrors.has('website') && (
                                        <span className="error text-danger">
                                            {convertReadbleFormat(formErrors.first('website'))}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <button type="submit" className="btn circle btn-light border btn-md">Request to learn more</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default"
              onClick={this.closeModal}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
    return {}
  }
  const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      sendBrandRequest: (data) => {
        return dispatch(sendBrandRequest(data));
      }
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(RequestBrand);



// WEBPACK FOOTER //
// ./src/modals/requestBrand.js